import { Stack } from '@mui/material'

import { Textarea } from '@/components/ui/textarea'
interface CopyPasteInputBulkImportProps {
  onCardsGenerated: () => void
  textareaValue: string
  handleTextareaChange: (value: string) => void
  placeholder: string
}

export function CopyPasteInputBulkImport({ textareaValue, handleTextareaChange, placeholder }: CopyPasteInputBulkImportProps) {
  return (
    <Stack
      sx={{
        position: 'relative',
        width: '100%',
        maxHeight: '200px',
        minHeight: '100px',
        borderRadius: '14px',
        gap: '4px',
        bgcolor: '#fff',
        border: '1px solid #D0D5DD',
        justifyContent: 'space-between',
      }}
    >
      <Textarea
        autoFocus
        className="border-none shadow-none  focus-visible:ring-0 placeholder:text-[#667085] font-normal h-full"
        placeholder={placeholder}
        rows={5}
        value={textareaValue}
        onChange={e => {
          handleTextareaChange(e.target.value)
        }}
      />
    </Stack>
  )
}
